document.addEventListener('DOMContentLoaded', ()=>{
  const links = document.querySelectorAll('.anchor-links__sticky button[data-section]');
  window.addEventListener('scroll', (event) => {
    const fromTop = window.scrollY;
    const announcementContainerHeight = document?.querySelector(".announcement-bar")?.clientHeight || 0
    const headerContainerHeight = document.querySelector(".section-header").clientHeight || 0
    const headerOffset = headerContainerHeight + announcementContainerHeight + document.querySelector('.anchor-links__sticky').clientHeight;
    links.forEach(link => {
      if(link.dataset.section == null) return
      const section = document.querySelector(`[data-anchor="${link.dataset.section}"]`).closest(".shopify-section");
      if (section) {
        if (section.offsetTop - headerOffset <= fromTop && section.offsetTop + section.clientHeight - headerOffset > fromTop) {
          link.classList.add('active');
          const htab_container = document.querySelector('.anchor-links__list');
          const htab_tabRect = link.getBoundingClientRect();
          const htab_containerRect = htab_container.getBoundingClientRect();
          const scrollLeft = htab_container.scrollLeft + (htab_tabRect.left - htab_containerRect.left) - (htab_containerRect.width / 2 - htab_tabRect.width / 2);
          htab_container.scrollTo({
            left: scrollLeft
          });
        } else {
          link.classList.remove('active');
        }
      }
    });
    if(document?.querySelectorAll('.anchor-links__sticky button[data-section].active')?.length == 0){
      document?.querySelector(".anchor-links__sticky button[data-view-all]")?.classList?.add("active");
    } else {
      document?.querySelector(".anchor-links__sticky button[data-view-all]")?.classList?.remove("active");
    }
  });
})